import { matchPath } from 'react-router-dom';
import { NotificationTranslation, RouteNotifications } from '../types';

export type RouteScopedNotifications = {
    entries: NotificationTranslation[];
    scopedToRoute: boolean;
};

export function notificationsForRoute(
    pathname: string,
    all: NotificationTranslation[],
    headerKeys: string[],
    routes: RouteNotifications[]
): RouteScopedNotifications {
    const route = routes.find(
        (candidate) =>
            matchPath(pathname, { path: candidate.path, exact: candidate.exact }) !== null
    );
    if (!route) {
        return { entries: all, scopedToRoute: false };
    }

    const keys = headerKeys.concat(route.keys);
    return {
        entries: all.filter((entry) => keys.indexOf(entry.key) !== -1),
        scopedToRoute: true
    };
}
